module.exports = __webpack_public_path__ + "static/2018-idaho-private-100-logo-62f6efe13ffccfd8fc541c8fa33d17d6.svg";